module.exports = __webpack_public_path__ + "media/images/new_home/company-icon-500111e46b2c82a6b2fc20f3916150de.png";